import React, { useState } from "react";
import { useParams } from "react-router";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import ButtonDisable from "../../partials/other/ButtonDisable";
import helpersNumbers from "../../../helpers/numbers";
import tickets from "./tickets";

export default function ViewTickets() {
  const [tagFileAttachment, setTagFileAttachment] = useState([]);
  const params = useParams();
  const ticketID = params.id;
  let ticket = tickets.filter((ticket) => ticket.id == ticketID);
  ticket = ticket[0];

  const AddTicketAttachment = () => {
    const tagsExampleTicketAttachment = (
      <div className="py-2">
        <input
          type="file"
          name="file"
          accept=".png, .jpeg,.jpg,.txt, .pdf,.doc, .docx"
          className="form-control"
        />
      </div>
    );

    setTagFileAttachment([...tagFileAttachment, tagsExampleTicketAttachment]);
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="نمایش تیکت" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="card">
                <div
                  className="card-header bg-success hover"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  <div className="d-flex justify-content-between">
                    <div className="d-flex">
                      <div className="pl-2">
                        <i className="fa fa-check"></i>
                      </div>
                      <div>پاسخ</div>
                    </div>
                  </div>
                </div>
                <form encType="multipart/form-data">
                  <div
                    id="collapseOne"
                    className="collapse show "
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      <div className="form-group">
                        <label>متن</label>
                        <textarea
                          className="form-control"
                          id="text"
                          rows="10"
                          name="text"
                        ></textarea>
                      </div>
                      <ButtonDisable
                        buttonTagHtml={
                          <span className="btn btn-success opacity-50">
                            ارسال
                          </span>
                        }
                      />
                    </div>
                    <div className="card-footer">
                      <div className="row form-group">
                        <div className="col-sm-3 col-sm-push-9">
                          <button
                            type="button"
                            className="btn btn-default btn-block"
                            onClick={AddTicketAttachment}
                          >
                            <i className="fa fa-plus"></i> افزودن موارد دیگر
                          </button>
                        </div>
                        <div className="col-sm-9 col-sm-pull-3">
                          <input
                            type="file"
                            name="file"
                            accept=".png, .jpeg,.jpg,.plain, .pdf,.doc, .docx"
                            className="form-control"
                          />
                          <div id="fileUploadsContainer"></div>
                        </div>
                        <div className="col-xs-12 ticket-attachments-message text-muted">
                          پسوند های مجاز: jpg, .jpeg, .png, .txt, .doc
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div className="card">
                <div className="card-header bg-primary ">
                  <div className="d-flex justify-content-between">
                    <div className="d-flex">
                      <div className="pl-2">
                        <i className="fa fa-user"></i>
                      </div>
                      <div>پشتیبان</div>
                    </div>
                    <div className="d-inline-block">
                      {helpersNumbers.toPersianNum(ticket.updatedAt)}
                    </div>
                  </div>
                </div>
                <div className="card-body text-justify">
                  <p>{ticket.answer}</p>
                </div>
                <div className="card-footer">
                  <div className="d-flex align-items-center ">
                    <div className="pl-2"> فایل های آپلود شده: </div>
                    <div className="d-flex"></div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-header bg-danger ">
                  <div className="d-flex justify-content-between">
                    <div className="d-flex">
                      <div className="pl-2">
                        <i className="fa fa-user"></i>
                      </div>
                      <div>رضا احمدی</div>
                    </div>
                    <div className="d-inline-block">
                      {helpersNumbers.toPersianNum(ticket.createAt)}
                    </div>
                  </div>
                </div>
                <div className="card-body text-justify">
                  <p>{ticket.question}</p>
                </div>
                <div className="card-footer">
                  <div className="d-flex align-items-center ">
                    <div className="pl-2"> فایل های آپلود شده: </div>
                    <div className="d-flex"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
